//package Import
import React, { useEffect, useState, useRef } from "react";
import { approveSellShare, rejectApproval } from "../../services/apiServices/PostServices";
import { ShareValueDetials } from "../../services/apiServices/GetServices";

//component import
import Modal from 'react-bootstrap/Modal';
import CustomModal from "./CustomModal";
import { showToast } from "../constants/Toaster";
import Loader from "../../components/loadingScreens/Loader";

const DetailedViewBuyShares = (props) => {
  const { close, open, userId, data, valueDetails } = props;
  const [show, setShow] = useState(false);
  const [shareQuantity, setshareQuantity] = useState()
  const [amount, setAmount] = useState("")
  const [deleteModal, setDeleteModal] = useState(false)
  const [rejectModal, setRejectModal] = useState(false)
  const [approvalConfirmModal, setApprovalConfirmModal] = useState(false)
  const [modalBlur, setModalBlur] = useState(false)
  const [shareValues, setShareValues] = useState([])
  const totalAmountInvested = props?.totalAmount
  const [isLoader, setIsLoader] = useState(false)

  const handleDeleteModal = () => setDeleteModal(false)
  const modalRef = useRef();
  //function for handle modal backDrop Click
  const handleBackdropClick = (e) => {
    if (modalRef.current && !modalRef.current.contains(e.target)) {
      // Handle the click outside the modal (e.g., prevent closing the modal)
      e.preventDefault();
      e.stopPropagation();
    }
  };

  useEffect(() => {
    callShareDetailsApi()
  }, []);

  useEffect(() => {
    if (data !== undefined) {
      callBuyAmount()
    }
  }, [data]);

  //function call to handle buy amount
  const callBuyAmount = () => {
    let amountValue = handleShareAmount(data?.buy_amount, data?.share_value)
    setshareQuantity(amountValue)
  }

  //function call to handle share quanity value
  const hanldeShareQuantity = (value) => {
    let val = parseInt(value)
    setshareQuantity(val)
  }

  //function call to call sharedetails values
  const callShareDetailsApi = async () => {
    const res = await ShareValueDetials("osanShares")
    if (res?.success) {
      setShareValues(res?.osanShares)
      // setRange1Val(res?.osanShares[0]?.value)
      // setRange2Val(res?.osanShares[1]?.value)
      // setRange1MaxValue(res?.osanShares[0]?.to_)
    } else {
      console.log("res", res?.message)
    }
  }

  const handleShareAmount = (amount, value) => {
    const alreadyInvested = totalAmountInvested === null ? 0 : parseInt(totalAmountInvested)
    const totalAmount = amount / value

    return totalAmount

  }

  const handleApproveBuyRequest = async () => {
     setIsLoader(true)
    let shares = shareQuantity
    if (shares !== undefined) {
      const reqbody = {
        user_id: userId,
        share_id: data?.id,
        buy_shares: shares
      }
      const res = await approveSellShare(`buyShares`, reqbody);
      if (res?.success) {
        showToast(1, res?.message)
        setApprovalConfirmModal(false)
        setModalBlur(false)
        setAmount("")
        close()
      } else {
        // showToast(3, res?.message)
        console.log("res", res?.message)
      }
    } else {
      console.log("error shares undefined")
    }
  }

  const handleClose = () => {
    setShow(false)
    setModalBlur(false)
  }

  //function call to open reject modal
  const handleRejectOpen = () => {
    setRejectModal(true)
    setModalBlur(true)
  }

  //function call to call rejection api
  const handleRejectAction = async (val) => {
    const message = val
    if (message === "") {
      showToast(3, "Please enter reason in the reason field")
    } else {
      // setIsLoader(true)
      const reqBody = {
        user_id: props?.userId,
        share_id: props?.data?.id,
        message: message
      }
      const res = await rejectApproval(`reject`, reqBody);
      if (res?.success) {
        showToast(1, res?.message)
        handleCloseReject()
        setModalBlur(false)
        close()
      } else {
        // showToast(3, res?.message)
        console.log("res", res?.message)
      }
    }
  }

  const handleApproveRequest = () => {
    setModalBlur(true)
    setApprovalConfirmModal(true)
  }

  //function call to close reject modal
  const handleCloseReject = () => {
    setModalBlur(false)
    setRejectModal(false)
  }

  //function call to close reject modal
  const handleCloseApprove = () => {
    setApprovalConfirmModal(false)
    setModalBlur(false)
  }

  const handleCloseModal = () => {
    setAmount("")
    close()
  }

  //function to delete image
  const handleImageDelte = () => {
    setDeleteModal(false)
  }

  //function to open preview modal
  const handleOpenPreview = () => {
    setModalBlur(true)
    setShow(true)
  }

  const hadlePlusSign = () => {
    setshareQuantity(shareQuantity + 1)
  }

  const hadleMinusSign = () => {
    setshareQuantity(shareQuantity - 1)
  }


  return (
    <>
        <Modal show={open} onHide={handleCloseModal} aria-labelledby="contained-modal-title-vcenter"
      centered size={"md"} backdrop="static" data-bs-theme="dark" onClick={handleBackdropClick} >
      <div class={modalBlur ? "blurBackground" : ""}>
        {/* {isLoader ? <Loader /> : null} */}
        <Modal.Header style={{ backgroundColor: "#0A2FB6" }} closeButton>
          <h6 class="text-white fw-bold m-0 montserrat" >Detail View - Buy Request</h6>
        </Modal.Header>
        <div class="d-flex flex-column w-100 justify-content-center align-items-center mx-4">
          <div class="d-flex flex-column align-self-start mx-2 w-100 my-2">
            <div class="d-flex w-100">
              <div class="d-flex flex-column w-75">
                <div class="d-flex ">
                  <h6 class="subHeading w-50  roboto">Requested Amount </h6>
                  <h6 class="mx-2   m-0 w-50 status-pending fw-normal"> :  ₹{data?.buy_amount}</h6>
                </div>
                <div class="d-flex  ">
                  <h6 class="subHeading w-50 roboto">Approx. Share Quantities</h6>
                  <h6 class="mx-2  m-0 w-50 status-pending fw-normal"> : {handleShareAmount(data?.buy_amount, data?.share_value)}</h6>
                </div>
                <div class="d-flex ">
                  <h6 class="subHeading w-50 roboto">Share Name</h6>
                  <h6 class="mx-2  ms-2 w-50 m-0 status-pending fw-normal"> : {data?.share_name}</h6>
                </div>
                <div class="d-flex ">
                  <h6 class="subHeading w-50 roboto">Share Value</h6>
                  <h6 class="mx-2 ms-2 w-50 m-0 status-pending fw-normal"> :  {data?.share_value}</h6>
                </div>
                <div class="d-flex  ">
                  <h6 class="subHeading  w-50 m-0 mt-1  roboto"> Message </h6>
                  <h6 class="status-pending  mt-1  text-break roboto"> : {data?.message === undefined ? "-" : data?.message} </h6>
                </div>
              </div>
              <div class="d-flex w-50  " >
                <div class="d-flex cursorPointer" onClick={handleOpenPreview}>
                  <div class="d-flex w-50 flex-column" >
                    <img src={data?.image_url} class="imageShareCss" alt="previewImg" />
                    <h6 class="w-25  previewColor">Preview</h6>
                  </div>

                </div>
              </div>
            </div>

          </div>

        </div>
        <div class="p-4 pb-0">
          <div class="d-flex flex-column   border w-100 ">
            <div class="d-flex  justify-content-between border-bottom p-1 flex-row ">
              <div class="w-50">
                <h6>Amount</h6>
              </div>
              <div class="w-25 text-start me-3">
                ₹{data?.buy_amount}
              </div>

            </div>
            <div class="d-flex  justify-content-between border-bottom p-1 flex-row ">
              <div class="w-50">
                <h6>Approx. Share Quantities </h6>
              </div>

              <div class="w-50 text-end" >
                <i class="bi bi-dash  " onClick={() => hadleMinusSign()}></i>
                <input value={shareQuantity}
                  type="Number"
                  onChange={(e) => {
                    hanldeShareQuantity(e.target.value)
                  }}
                  class="amountStyle shadow"
                />
                <i class="bi bi-plus cursorPointer" onClick={() => hadlePlusSign()}></i>
              </div>
            </div>
          </div>


          <div class="d-flex flex-column mt-4 mb-0 w-100">
            <div class="d-flex  my-1 align-self-center mb-2">
              <button class="primaryButton px-3 mx-2" onClick={() =>handleApproveRequest()} >
                Approve
              </button>
              <button class="primaryButton px-4 mx-2" onClick={() => handleRejectOpen()}  >
                Reject
              </button>
            </div>
          </div>

        </div>
      </div>
    </Modal>
     <CustomModal
          close={handleDeleteModal}
          open={deleteModal}
          Action={handleImageDelte}
          modalContent={"Are you sure want to delete the image?"}
        />
        <CustomModal
          close={handleClose}
          open={show}
          imgvalue={data?.image_url}
        />
        <CustomModal
          close={handleCloseReject}
          open={rejectModal}
          RejectAction={handleRejectAction}
          type="reject"
          modalContent={"Are you sure want to reject the approval?"}
        />
        
        <CustomModal
          close={handleCloseApprove}
          open={approvalConfirmModal}
          Action={handleApproveBuyRequest}
          type={"approval"}
          modalContent={"Are you sure want to approval the buy request?"}
        />
    </>

  )
}

export default DetailedViewBuyShares